/**
 * initScrollUp
 * @description Manages the visibility of the scroll-to-top button
 */
export default function initScrollUp() {
  document.addEventListener('DOMContentLoaded', () => {
    const scrollTop = document.querySelector('#scrolltop');
    if (!scrollTop) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        scrollTop.style.visibility = 'visible';
        scrollTop.style.opacity = 1;
      } else {
        scrollTop.style.visibility = 'hidden';
        scrollTop.style.opacity = 0;
      }
    });
  });
}
